var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ur-screen',[_c('div',{staticClass:"body-wrapper"},[_c('ur-area',{staticClass:"custom-content",attrs:{"right":""}},[_c('div',{staticClass:"page-custom-container"},[_c('router-view')],1)])],1),_c('ur-area',[_c('LayoutFooter')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }